<div style="display: flex; flex-wrap: wrap; flex-direction: row; gap: 10px">
    <a *ngIf="
            campaign.startDate &&
            campaign.endDate &&
            userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.PREVIEW)
        " href="javascript:;" (click)="triggerAction(CampaignAction.PREVIEW, { id: campaign._id })"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/preview.svg" alt="Preview campaign" title="Preview campaign"
            width="20" />
    </a>
    <a *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.EDIT)" href="javascript:;"
        (click)="triggerAction(CampaignAction.EDIT, { id: campaign._id, status: campaign.status })"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/edit.svg" alt="Edit media" title="Edit media" width="20" />
    </a>
    <a (click)="
            triggerAction(CampaignAction.PAUSE_VISUALS, {
                id: campaign._id
            })
        " *ngIf="
            userStatusAction[currentUserRole][campaign.status]?.includes(
                CampaignAction.PAUSE_VISUALS
            )
        "
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/screen-pause.svg" alt="Pause campaign visuals"
            title="Pause campaign visuals" style="width: 60% !important" />
    </a>
    <a (click)="triggerAction(CampaignAction.DELETE, { id: campaign._id })"
        *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.DELETE)"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/trash.svg" alt="Delete campaign" title="Delete campaign"
            style="width: 70% !important" />
    </a>

    <a (click)="
            triggerAction(CampaignAction.PAUSE, {
                dataSource: dataSource.dataSource,
                id: campaign._id
            })
        " *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.PAUSE)"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-white">
        <mat-icon title="Pause campaign">pause</mat-icon>
    </a>

    <a (click)="
            triggerAction(CampaignAction.RELAUNCH, {
                dataSource: dataSource.dataSource,
                id: campaign._id
            })
        " *ngIf="
            userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.RELAUNCH)
        "
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/rocket.svg" alt="Relaunch campaign" title="Relaunch campaign"
            style="width: 65% !important; padding-top: 2px" />
    </a>

    <div *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.CANCEL)"
        style="position: relative; display: inline-block">
        <div *ngIf="shouldShowAlertIcon()" style="position: absolute; top: -12px; right: -12px; z-index: 10"
            [title]="getAlertTooltip()">
            🚨
        </div>

        <a (click)="
                triggerAction(CampaignAction.CANCEL, {
                    dataSource: dataSource.dataSource,
                    id: campaign._id
                })
            "
            class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
            <img src="./assets/images/icons/common/times-solid-white.svg" alt="Cancel campaign" title="Cancel campaign"
                style="width: 60% !important" />
        </a>
    </div>

    <a (click)="
            triggerAction(CampaignAction.STOP, {
                dataSource: dataSource.dataSource,
                id: campaign._id
            })
        " *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.STOP)"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500">
        <img src="./assets/images/icons/common/stop.svg" alt="Stop campaign" title="Stop campaign"
            style="width: 60% !important" />
    </a>

    <div (click)="
            triggerAction(CampaignAction.RESTORE, {
                id: campaign._id
            })
        " *ngIf="canShowRestore()" style="transform: rotate(90deg)"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/arrow-white.svg" alt="Restore campaign previous state"
            title="Restore campaign to previous state" width="40" />
    </div>
    <a href="javascript:;" *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.APPROVE)"
        (click)="triggerAction(CampaignAction.APPROVE, { id: campaign._id })"
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary"
        [ngClass]="{
            disabled: campaign.beingEdited
        }">
        <img src="./assets/images/icons/common/tick-white.svg" alt="Approve campaign" title="Approve campaign"
            width="20" />
    </a>
    <a href="javascript:;" *ngIf="userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.REJECT)"
        (click)="
            triggerAction(CampaignAction.REJECT, {
                id: campaign._id
            })
        "
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary"
        [ngClass]="{
            disabled: campaign.beingEdited
        }">
        <img src="./assets/images/icons/common/times-solid-white.svg" alt="Reject campaign" title="Reject campaign"
            width="20" />
    </a>
    <a (click)="
            triggerAction(CampaignAction.ADD_CHARGES, {
                dataSource: dataSource.dataSource,
                id: campaign._id
            })
        " *ngIf="
            userStatusAction[currentUserRole][campaign.status]?.includes(CampaignAction.ADD_CHARGES)
        "
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/credit-card-add.svg" alt="Add charges" title="Add charges"
            style="width: 60% !important" />
    </a>
    <a (click)="
            triggerAction(CampaignAction.DOWNLOAD_MEDIA, {
                id: campaign._id,
                title: campaign.title
            })
        " *ngIf="
            userStatusAction[currentUserRole][campaign.status]?.includes(
                CampaignAction.DOWNLOAD_MEDIA
            )
        "
        class="edit-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
        <img src="./assets/images/icons/common/arrow-white.svg" alt="Download Media" title="Download Media"
            width="20" />
    </a>
</div>